import React, { useCallback, useEffect, useRef, useState } from 'react';
import { HiX } from 'react-icons/hi';
import PersonalInfo from './personalInfo';
import axios from 'axios';

const DownloadModal = ({
  closePop,
  setClosePopUp,
  setConfirmDownload,
  productTarget,
  setProductTarget,
}) => {
  const inputRef = useRef([]);
  const emailForm = /^[a-zA-Z]+\.[a-zA-Z]+$/;
  const specialChar = /^[A-Za-z0-9-._]*$/g;

  const inputValue = {
    productTarget: productTarget,
    qSize: '30',
    cor_name: '',
    mng_name: '',
    phone: '010',
    phone1: '',
    phone2: '',
    email: '',
    emailDomain: '',
  };
  const [values, setValues] = useState(inputValue);
  const { qSize, cor_name, mng_name, phone, phone1, phone2, email, emailDomain } = values;

  const [loading, setLoading] = useState(false);
  const [privacyChk, setPrivacyChk] = useState(false);

  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      if (loading) {
        return false;
      }
      for (let i = 0; i < inputRef.current.length; i++) {
        if (inputRef.current[i].value === '' || !inputRef.current[i].value.trim()) {
          alert(inputRef.current[i].title + '을(를) 입력해주세요.');
          inputRef.current[i].focus();
          return false;
        }
      }
      if (phone1.length < 3) {
        alert('연락처를 확인해주세요.');
        inputRef.current[2].focus();
        return false;
      }
      if (phone2.length < 4) {
        alert('연락처를 확인해주세요.');
        inputRef.current[3].focus();
        return false;
      }
      if (!specialChar.test(email)) {
        alert('이메일 아이디를 확인해주세요. (특수문자는 ".-_"만 허용됩니다.)');
        inputRef.current[4].focus();
        return false;
      }
      if (!emailForm.test(emailDomain)) {
        alert('이메일 도메인을 확인해주세요');
        inputRef.current[5].focus();
        return false;
      }

      if (privacyChk === false) {
        alert('개인정보 수집 및 이용을 동의해주세요');
        return false;
      }
      try {
        setLoading(true);
        axios
          .post(
            `https://backwithus.kiwontech.com/customer/download/logSave`,
            {
              catalogue_gubun: values.productTarget,
              qSize: qSize,
              cor_name: cor_name,
              mng_name: mng_name,
              phone: `${phone}-${phone1}-${phone2}`,
              email: `${email}@${emailDomain}`,
            },
            {
              headers: {
                'Content-Type': `application/x-www-form-urlencoded`,
              },
            },
          )
          .then((res) => {
            setValues({ ...inputValue });
          });
      } catch (error) {
        alert('오류가 발생했습니다. 관리자에게 연락 부탁드립니다.');
      } finally {
        setLoading(false);
        setClosePopUp(false);
        setConfirmDownload(true);
      }
    },
    [values, privacyChk],
  );

  useEffect(() => {
    document.body.style.cssText = `
    position: fixed;
    top: -${window.scrollY}px;
    overflow-y: scroll;
    width: 100%;`;
    return () => {
      const scrollY = document.body.style.top;
      document.body.style.cssText = '';
      window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
    };
  }, []);

  return (
    <>
      <form onSubmit={onSubmit}>
        <section className="modalWrap" onClick={closePop}>
          <div className="modalBody" onClick={(e) => e.stopPropagation()}>
            <div className="w850">
              <div className="title">
                <h2>
                  {productTarget.indexOf('EG') === 0 && 'EG-Platform'}
                  {productTarget.indexOf('SO') === 0 && 'SentinelOne'}
                  {productTarget.indexOf('BP') === 0 && 'BaroPAM'}
                  &nbsp; 자료 다운로드
                </h2>
                <p>
                  자료 다운로드를 위해 아래 정보를 <br className="w600" /> 입력하여 주시기 바랍니다.
                </p>
              </div>
              <div className="scrollBox">
                <div className="w800">
                  <div className="inputBox">
                    <label>
                      <span className="inputTit">회사 규모</span>
                      <select onChange={handleChange} value={qSize} name="qSize">
                        <option value="30">30명 이하</option>
                        <option value="50">50명 이하</option>
                        <option value="100">100명 이하</option>
                        <option value="300">300명 이하</option>
                        <option value="500">500명 이하</option>
                        <option value="1000">1000명 이하</option>
                        <option value="9999">1000명 초과</option>
                      </select>
                    </label>
                    <label>
                      <span className="inputTit">회사명</span>
                      <input
                        type="text"
                        value={cor_name}
                        name="cor_name"
                        title="회사명"
                        onChange={handleChange}
                        ref={(el) => (inputRef.current[0] = el)}
                        placeholder="회사명을 입력해 주세요."
                      />
                    </label>
                    <label>
                      <span className="inputTit">담당자명</span>
                      <input
                        type="text"
                        value={mng_name}
                        name="mng_name"
                        title="담당자명"
                        onChange={handleChange}
                        ref={(el) => (inputRef.current[1] = el)}
                        placeholder="담당자명을 입력해 주세요."
                      />
                    </label>
                    <label>
                      <span className="inputTit">연락처</span>
                      <div className="num">
                        <select value={phone} name="phone" onChange={handleChange}>
                          <option value="010">010</option>
                          <option value="011">011</option>
                          <option value="016">016</option>
                          <option value="017">017</option>
                          <option value="018">018</option>
                          <option value="019">019</option>
                        </select>
                        -
                        <input
                          type="text"
                          value={phone1.replace(/[^0-9]/g, '')}
                          name="phone1"
                          title="연락처"
                          maxLength="4"
                          onChange={handleChange}
                          ref={(el) => (inputRef.current[2] = el)}
                        />
                        -
                        <input
                          type="text"
                          value={phone2.replace(/[^0-9]/g, '')}
                          name="phone2"
                          title="연락처"
                          maxLength="4"
                          onChange={handleChange}
                          ref={(el) => (inputRef.current[3] = el)}
                        />
                      </div>
                    </label>
                    <label>
                      <span className="inputTit">이메일</span>
                      <div className="mail">
                        <div className="flex">
                          <input
                            type="text"
                            value={email}
                            name="email"
                            title="이메일"
                            onChange={handleChange}
                            ref={(el) => (inputRef.current[4] = el)}
                            placeholder="이메일을 입력해 주세요."
                          />
                          <span>@</span>
                        </div>
                        <input
                          type="text"
                          value={emailDomain === '' ? emailDomain : emailDomain}
                          name="emailDomain"
                          title="이메일 도메인"
                          onChange={handleChange}
                          ref={(el) => (inputRef.current[5] = el)}
                        />
                        <select onChange={handleChange} value={emailDomain} name="emailDomain">
                          <option value="">직접입력</option>
                          <option value="gmail.com">gmail.com</option>
                          <option value="naver.com">naver.com</option>
                          <option value="hanmail.net">hanmail.net</option>
                        </select>
                      </div>
                    </label>
                  </div>
                  <PersonalInfo privacyChk={privacyChk} setPrivacyChk={setPrivacyChk} />
                  <div className="btn">
                    <button className="apply">신청하기</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="closeBtn">
              <button type="button" onClick={closePop}>
                <HiX />
              </button>
            </div>
          </div>
        </section>
      </form>
    </>
  );
};

export default DownloadModal;
